import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { ApiEvent } from 'modules/listing/api/event/types/ApiEvent';

export function isUserEventOwner(
  user: ApiUser | null | undefined,
  event: ApiEvent | null | undefined,
): boolean {
  return Boolean(user?.id && event && user.id === event.creator?.userId);
}
